// https://fanduel.atlassian.net/wiki/spaces/FAW/pages/310220522689/Amplitude+Casino+next.js+Web+Migration+-+Global+Navigation
import { getEventPropsBuilder, toSnakeCase } from '../../utils';
import type { AmplitudeEventKeys } from '../../amplitude-properties.types';

type NavigatedToEvent = {
    module: string;
    linkText: string;
    linkUrl: string;
    tag?: string;
    personalized?: boolean;
    pinnedCategory?: boolean;
    linkType?: 'category' | 'non_category';
    category?: string;
};

export const getNavigatedToProps = getEventPropsBuilder((e: NavigatedToEvent): Partial<AmplitudeEventKeys> => {
    return {
        event: 'Navigation Link Clicked',
        Module: toSnakeCase(e.module),
        'Link Text': toSnakeCase(e.linkText),
        'Event Category': 'navigation',
        'Link URL': e.linkUrl,
        'Full URL': `${window.location.origin}${e.linkUrl}`,
        Hostname: window.location.hostname,
        'Page Path': e.linkUrl,
        Tag: e.tag || '',
        ...(e.personalized && { Personalized: e.personalized ? 'true' : null }),
        ...(e.pinnedCategory !== undefined && { 'Pinned Category': e.pinnedCategory ? 'true' : null }),
        ...(e.linkType !== undefined && { 'Link Type': e.linkType }),
        ...(e.category !== undefined && { Category: toSnakeCase(e.category) })
    };
});
